import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const VORPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  maintenanceManagerContact,
  fleetManagerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "VOR_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Vehicle Off Road (VOR) Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy establishes the procedures for managing vehicles declared Vehicle Off Road (VOR) due to defects, maintenance issues, or safety concerns to ensure safety and compliance.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        Applies to all company vehicles that are temporarily taken out of service due to roadworthiness or maintenance issues.
      </p>

      <h4 className="section-title">3. Identification and Declaration</h4>
      <ul>
        <li>Vehicles with defects affecting safety, legal compliance, or operational capability must be immediately declared VOR.</li>
        <li>The driver or maintenance personnel must notify the Fleet Manager or Maintenance Manager promptly.</li>
        <li>A visible VOR sign or label must be placed on the vehicle to indicate its status. The company provides a printable VOR sign within this app’s Print Offs section for convenience and compliance.</li>
      </ul>

      <h4 className="section-title">4. Documentation and Communication</h4>
      <ul>
        <li>A VOR form must be completed detailing the reasons for the VOR status, defect description, and expected repair timeline.</li>
        <li>All relevant personnel including drivers, maintenance, and management must be informed immediately.</li>
        <li>VOR status and updates must be logged in the fleet management system.</li>
      </ul>

      <h4 className="section-title">5. Repair and Return to Service</h4>
      <ul>
        <li>Repairs must be completed promptly, prioritising safety and compliance requirements.</li>
        <li>Post-repair inspections and tests must be conducted to verify roadworthiness before returning to service.</li>
        <li>Only authorised personnel may remove the VOR status once vehicle safety is confirmed.</li>
      </ul>

      <h4 className="section-title">6. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Fleet Manager:</strong> Oversees VOR declarations, repairs, and communications. Contact: {fleetManagerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Maintenance Manager:</strong> Coordinates repair works and ensures compliance. Contact: {maintenanceManagerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Drivers:</strong> Must report defects and comply with VOR procedures.</p>

      <h4 className="section-title">7. Record Keeping and Review</h4>
      <p className="section-content">
        All VOR incidents and repairs will be recorded and reviewed periodically to identify trends and improve maintenance practices.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Vehicle Off Road (VOR) Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default VORPolicy;
